import { Integration, IntegrationDetail } from './types';

export const integrations: Integration[] = [
  {
    id: 'sentinelone',
    name: 'SentinelOne',
    vendor: 'SentinelOne',
    category: 'Endpoint Security',
    description:
      'SentinelOne delivers autonomous endpoint protection through a single agent that prevents, detects, and responds to attacks across all major vectors. Powered by AI, it provides real-time protection for every endpoint in your organization.',
    icon: 'S1',
    logoUrl:
      'https://images.yourstory.com/cs/images/companies/SentineIOne-1663844879511.jpg?fm=auto&ar=1:1&mode=fill&fill=solid&fill-color=fff',
    badges: ['Endpoint Security'],
    capabilities: ['Automation', 'Log Ingestion'],
    automation: true,
    logIngestion: true,
    comingSoon: false,
  },
  {
    id: 'splashtop',
    name: 'Splashtop',
    vendor: 'Splashtop',
    category: 'Remote Access',
    description:
      'Splashtop is the #1 rated remote access and support software trusted by 30 million users. It provides secure remote access, remote support, and autonomous endpoint management with enterprise-grade security including 2FA, E2E encryption, and SOC 2 compliance.',
    icon: 'SP',
    logoUrl: 'https://tse1.mm.bing.net/th/id/OIP.kCPjnjuRpLd0vfgdoHMdaQHaHa?w=1200&h=1200&rs=1&pid=ImgDetMain&o=7&rm=3',
    badges: ['Remote Access'],
    capabilities: ['Partner Hosted', 'Automation'],
    partnerHosted: true,
    automation: true,
    comingSoon: false,
  },
  {
    id: 'tenable',
    name: 'Tenable',
    vendor: 'Tenable',
    category: 'Vulnerability Management',
    description:
      'Tenable is the Exposure Management company, providing the broadest vulnerability coverage with the ability to predict which security issues to remediate first. Tenable Nessus is trusted by over 30,000 organizations worldwide for vulnerability assessment.',
    icon: 'TN',
    logoUrl: 'https://www.tenable.com/themes/custom/tenable/images-new/favicons/favicon-96x96.png',
    badges: ['Vulnerability Management'],
    capabilities: ['Log Ingestion', 'Enrichment'],
    logIngestion: true,
    enrichment: true,
    comingSoon: true,
  },
  {
    id: 'rapid7',
    name: 'Rapid7',
    vendor: 'Rapid7',
    category: 'Security Analytics',
    description:
      'Rapid7 accelerates security operations through comprehensive visibility, analytics, and automation. Its InsightIDR SIEM and InsightVM vulnerability management solutions help security teams detect attackers, respond to breaches, and eliminate vulnerabilities.',
    icon: 'R7',
    logoUrl: 'https://companieslogo.com/img/orig/RPD-d8fbf4f2.png?t=1720244493&download=true',
    badges: ['Security Analytics'],
    capabilities: ['Log Ingestion', 'Enrichment'],
    logIngestion: true,
    enrichment: true,
    comingSoon: true,
  },
  {
    id: 'servicenow',
    name: 'ServiceNow',
    vendor: 'ServiceNow',
    category: 'IT Service Management',
    description:
      'ServiceNow is the digital workflow platform that modernizes IT service management. It streamlines and automates workflows across IT, security, and operations, connecting people, functions, and systems to accelerate innovation and drive business outcomes.',
    icon: 'SN',
    logoUrl: 'https://www.servicenow.com/content/dam/servicenow-assets/public/en-us/images/og-images/favicon.ico',
    badges: ['IT Service Management'],
    capabilities: ['Automation', 'Log Ingestion'],
    automation: true,
    logIngestion: true,
    comingSoon: true,
  },
  {
    id: 'freshservice',
    name: 'Freshservice',
    vendor: 'Freshworks',
    category: 'IT Service Management',
    description:
      'Freshservice is a cloud-based AI-powered IT service management solution that enables IT teams to modernize support delivery and operations. Manage IT assets, incidents, and service requests with a frictionless experience for employees.',
    icon: 'FS',
    logoUrl: 'https://www.freshworks.com/favicons/apple-touch-icon.png',
    badges: ['IT Service Management'],
    capabilities: ['Automation'],
    automation: true,
    comingSoon: true,
  },
  {
    id: 'appbridge-ai',
    name: 'Appbridge AI',
    vendor: 'Appbridge AI',
    category: 'AI Integration',
    description:
      'Appbridge AI enables seamless integration between enterprise applications using AI-powered connectors and workflows. It automates data exchange, reduces manual effort, and accelerates digital transformation by intelligently bridging siloed systems.',
    icon: 'AB',
    logoUrl:
      'https://media.licdn.com/dms/image/v2/D4D0BAQE0sygreU4kLg/company-logo_200_200/B4DZvmjg.fJYAI-/0/1769099629142?e=2147483647&v=beta&t=H37z3fMD9pkSOJHAVtt9yTancg3G0U12dC1XifUs4eA',
    badges: ['AI Integration'],
    capabilities: ['Automation', 'Enrichment'],
    automation: true,
    enrichment: true,
    comingSoon: true,
  },
  {
    id: 'crowdstrike',
    name: 'CrowdStrike',
    vendor: 'CrowdStrike',
    category: 'Endpoint Security',
    description:
      'CrowdStrike is a global cybersecurity leader that redefined modern security with the CrowdStrike Falcon platform. The AI-native Falcon platform stops breaches by unifying endpoint, identity, cloud, and data protection across the enterprise.',
    icon: 'CS',
    logoUrl: 'https://cdn.freelogovectors.net/wp-content/uploads/2023/12/crowdstrike_logo-freelogovectors.net_.png',
    badges: ['Endpoint Security'],
    capabilities: ['Log Ingestion', 'Automation'],
    logIngestion: true,
    automation: true,
    comingSoon: true,
  },
  {
    id: 'microsoft-defender',
    name: 'Microsoft Defender',
    vendor: 'Microsoft',
    category: 'Endpoint Security',
    description:
      'Microsoft Defender for Endpoint is an enterprise endpoint security platform designed to help networks prevent, detect, investigate, and respond to advanced threats. It delivers AI-powered, multi-platform endpoint protection across the enterprise.',
    icon: 'MD',
    logoUrl: 'https://vectorseek.com/wp-content/uploads/2023/08/Microsoft-Defender-Logo-Vector.svg-.png',
    badges: ['Endpoint Security'],
    capabilities: ['Log Ingestion', 'Enrichment'],
    logIngestion: true,
    enrichment: true,
    comingSoon: true,
  },
  {
    id: 'infraon',
    name: 'Infraon',
    vendor: 'Infraon',
    category: 'IT Operations',
    description:
      'Infraon is an AI-powered IT operations and service management platform that helps enterprises manage infrastructure, assets, and IT services. It provides unified visibility across the IT landscape with automated incident management and smart analytics.',
    icon: 'IN',
    logoUrl: 'https://play-lh.googleusercontent.com/nzP4f5KoYusKkIPZX39eHb3wQ9VxMUklFQpU5gUp5rnp04f8bOqLRnQ-3asKUvofh6AU',
    badges: ['IT Operations'],
    capabilities: ['Automation', 'Log Ingestion'],
    automation: true,
    logIngestion: true,
    comingSoon: true,
  },
];

export const integrationDetails: Record<string, IntegrationDetail> = {
  sentinelone: {
    id: 'sentinelone',
    name: 'SentinelOne',
    vendor: 'SentinelOne',
    category: 'Endpoint Security',
    description:
      'SentinelOne delivers autonomous endpoint protection through a single agent that prevents, detects, and responds to attacks across all major vectors.',
    icon: 'S1',
    logoUrl: 'https://logo.clearbit.com/sentinelone.com',
    badges: ['Endpoint Security'],
    availableIntegrations: [
      {
        id: 'sentinelone-agent',
        name: 'SentinelOne Autonomous Endpoint Protection',
        description:
          'Deploy and manage SentinelOne agents across your fleet from the Defatom platform. Provides real-time AI-powered threat detection, prevention, and automated response.',
        partnerHosted: false,
        logIngestion: true,
        type: 'Application',
        note: 'Use the official SentinelOne resources below for setup and deployment guidance.',
        installationLinks: [
          {
            label: 'SentinelOne Platform Overview',
            url: 'https://www.sentinelone.com/platform/singularity-platform/',
          },
          {
            label: 'SentinelOne Support Portal',
            url: 'https://support.sentinelone.com/',
          },
        ],
        quickLinks: [
          {
            label: 'SentinelOne Website',
            url: 'https://www.sentinelone.com/',
          },
          {
            label: 'SentinelOne Documentation',
            url: 'https://www.sentinelone.com/resources/',
          },
        ],
      },
    ],
  },
  splashtop: {
    id: 'splashtop',
    name: 'Splashtop',
    vendor: 'Splashtop',
    category: 'Remote Access',
    description:
      'Splashtop is the #1 rated remote access and support software trusted by 30 million users and 85% of Fortune 500 companies.',
    icon: 'SP',
    logoUrl: 'https://logo.clearbit.com/splashtop.com',
    badges: ['Remote Access'],
    availableIntegrations: [
      {
        id: 'splashtop-remote-support',
        name: 'Splashtop Remote Support & Endpoint Management',
        description:
          'Partner Hosted | Remotely access and support endpoints. Integrates endpoint management, patching, and remote access for IT teams directly within Defatom.',
        partnerHosted: true,
        logIngestion: false,
        type: 'Partner',
        note: 'This integration is provided by Splashtop. Use the official Splashtop links below for setup and licensing.',
        installationLinks: [
          {
            label: 'Splashtop Remote Support',
            url: 'https://www.splashtop.com/remote-support',
          },
          {
            label: 'Splashtop Enterprise Setup',
            url: 'https://www.splashtop.com/enterprise',
          },
        ],
        quickLinks: [
          {
            label: 'Splashtop Website',
            url: 'https://www.splashtop.com/',
          },
          {
            label: 'Splashtop Support',
            url: 'https://support-splashtopbusiness.splashtop.com/',
          },
        ],
      },
    ],
  },
};
